module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-layout"
  }, [_c('div', {
    staticClass: "form-rows",
    staticStyle: {
      "padding-bottom": "0px"
    }
  }, [_c('div', {
    staticClass: "fields input half left",
    class: {
      'has-error': _vm.errors.has('password_clear')
    }
  }, [_c('label', {
    attrs: {
      "for": "password_clear"
    }
  }, [_vm._v(_vm._s(_vm.locale.text_password_label) + " *")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ({
        rules: {
          required: true,
          max: 20,
          min: 8,
          password: true,
          confirmed: 'password_confirm'
        }
      }),
      expression: "{ rules: { required: true,  max: 20, min: 8, password: true, confirmed: 'password_confirm' } }"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.password),
      expression: "password"
    }],
    attrs: {
      "type": "password",
      "name": "password_clear",
      "id": "password_clear",
      "placeholder": _vm.locale.text_password_label
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.errors.has('password_clear')) ? _c('p', {
    staticClass: "text-danger"
  }, [_vm._v(_vm._s(_vm.errors.first('password_clear')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "fields input half right",
    class: {
      'has-error': _vm.errors.firstByRule('password_clear', 'confirmed') != null
    }
  }, [_c('label', {
    attrs: {
      "for": "password_confirm"
    }
  }, [_vm._v(_vm._s(_vm.locale.text_confirm_password_label) + " *")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "password",
      "name": "password_confirm",
      "id": "password_confirm",
      "placeholder": _vm.locale.text_confirm_password_label
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-rows"
  }, [_c('div', {
    staticClass: "fields input half right"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('input', {
    staticClass: "cta-button blue",
    attrs: {
      "type": "button",
      "value": _vm.locale.button_request_password
    },
    on: {
      "click": _vm.handle
    }
  })])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c4b7686"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/auth/forms/reset.vue
// module id = 162
// module chunks = 0